import { render } from "./firstSyncPendingItems.vue?vue&type=template&id=49ec151d&ts=true"
import script from "./firstSyncPendingItems.vue?vue&type=script&lang=ts"
export * from "./firstSyncPendingItems.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__